"use client";

import { signOut } from "aws-amplify/auth";
import { deleteDocumentCookie } from "./cookie-utils";

// Define a utility function
export async function ClearProjectCookies() {
  if (process.env.PROJECT === "Whatuni") {
    try {
      sessionStorage.clear();
      localStorage?.removeItem("resultSubmit");
      deleteDocumentCookie([
        { name: "wcache" },
        { name: "USER_FAV_BASKET_COUNT" },
        { name: "Signinonetap", options: { domain: ".whatuni.com" } },
        { name: "LoginSession", options: { domain: ".whatuni.com" } },
        { name: "LogedinviaOnetap", options: { domain: ".whatuni.com" } },
      ]);
      try {
        await signOut({ global: true });
      } catch (err) {
        console.error("Sign out failed:", err);
      }

      window.location.href = "/degrees/userLogin.html?e=logout";
    } catch (error) {
      console.error("Whatuni logout failed:", error);
    }
  } else {
    deleteDocumentCookie([
      { name: "pgs_auth" },
      { name: "pgs_bskt_cnt" },
      { name: "pgs_x" },
      { name: "pgs_userid" },
    ]);
    setTimeout(() => {
      const cookies: any = document.cookie
        .split(";")
        .reduce((acc: any, cookie: any) => {
          const [key, value] = cookie
            .split("=")
            ?.map((part: any) => part.trim());
          acc[key] = value;
          return acc;
        }, {});

      if (!cookies["pgs_auth"] && !cookies["pgs_bskt_cnt"]) {
        // Redirect only if cookies are deleted
        window.location.href = "/";
      }
    }, 100);
  }
}
